import { onAnimationEnd } from '@theme/utilities';

// Create a new custom element for product links with images for transitions to PDP
class ProductCardLink extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (event) => setTimeout(() => this.#handleClick(event), 0));
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#handleClick);
  }

  get productTransitionEnabled() {
    return this.getAttribute('data-product-transition') === 'true';
  }

  get featuredMediaUrl() {
    return this.getAttribute('data-featured-media-url');
  }

  /**
   * Handles the click event for the product link
   * @param {Event} event
   */
  #handleClick = (event) => {
    // If the event has been prevented, don't do anything, another component is handling the click or if it's an input (swatches)
    if (event.defaultPrevented || event.target instanceof HTMLInputElement) return;

    const gallery = this.querySelector('[data-view-transition-to-main-product]');
    if (!this.productTransitionEnabled || !(gallery instanceof HTMLElement)) return;

    // Rivello: a troca de srcset no clique era interrompida pela navegacao no iPhone e a foto
    // ficava quebrada ("?") ao voltar para a colecao. A transicao continua usando a foto atual do card.

    gallery.setAttribute('data-view-transition-type', 'product-image-transition');
    gallery.setAttribute('data-view-transition-triggered', 'true');
  };
}

if (!customElements.get('product-card-link')) {
  customElements.define('product-card-link', ProductCardLink);
}

// Rivello: ao voltar para a pagina (cache do navegador), recarrega fotos de card que ficaram quebradas
// e limpa as marcas de transicao do clique anterior.
if (!window.rvCardImageRepair) {
  window.rvCardImageRepair = true;
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    document.querySelectorAll('[data-view-transition-triggered]').forEach((el) => {
      el.removeAttribute('data-view-transition-triggered');
      el.removeAttribute('data-view-transition-type');
    });
    document.querySelectorAll('.card-gallery img').forEach((img) => {
      if (!(img instanceof HTMLImageElement)) return;
      if (img.complete && img.naturalWidth === 0) {
        const srcset = img.getAttribute('srcset');
        const src = img.getAttribute('src');
        img.removeAttribute('srcset');
        if (src) img.setAttribute('src', src + (src.includes('?') ? '&' : '?') + 'rv=' + Date.now());
        if (srcset) requestAnimationFrame(() => img.setAttribute('srcset', srcset));
      }
    });
  });
}
